import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpportunityItem } from '../models/opportunity.models';

@Component({
  selector: 'gig-opportunities-kpi-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './opportunities-kpi-bar.component.html',
  styleUrls: ['./opportunities-kpi-bar.component.scss'],
})
export class OpportunitiesKpiBarComponent {
  @Input() public items: OpportunityItem[] = [];

  public get totalOpen(): number {
    return this.items.filter(i => i.status !== 'DONE' && i.status !== 'IGNORED').length;
  }

  public get quickWins(): number {
    return this.items.filter(
      i => i.effort === 'LOW' && i.status !== 'DONE' && i.status !== 'IGNORED'
    ).length;
  }

  public get contentGaps(): number {
    return this.items.filter(
      i =>
        ['CONTENT_GAP', 'CANNIBALIZATION', 'DECAY'].includes(i.type) &&
        i.status !== 'DONE' &&
        i.status !== 'IGNORED'
    ).length;
  }

  public get technicalFixes(): number {
    return this.items.filter(
      i => i.type === 'TECHNICAL_FIX' && i.status !== 'DONE' && i.status !== 'IGNORED'
    ).length;
  }

  public get localSeo(): number {
    return this.items.filter(
      i => i.type === 'LOCAL' && i.status !== 'DONE' && i.status !== 'IGNORED'
    ).length;
  }

  public get competitorGaps(): number {
    return this.items.filter(
      i =>
        ['COMPETITOR_CONTENT_GAP', 'LINK_INTERSECT', 'COMPETITOR_RANK_LOSS'].includes(i.type) &&
        i.status !== 'DONE' &&
        i.status !== 'IGNORED'
    ).length;
  }

  public get reviewSignals(): number {
    return this.items.filter(
      i =>
        ['REVIEW_REPUTATION_RISK', 'REVIEW_RATING_DECLINE'].includes(i.type) &&
        i.status !== 'DONE' &&
        i.status !== 'IGNORED'
    ).length;
  }
}
